var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"keyword",on:{"click":function($event){return _vm.onWordClick()}}},[_vm._v(_vm._s(_vm.keyword.keyword))])}
var staticRenderFns = []

export { render, staticRenderFns }